import { render, staticRenderFns } from "./StarDivider.vue?vue&type=template&id=6ebfbf18"
import script from "./StarDivider.vue?vue&type=script&lang=js"
export * from "./StarDivider.vue?vue&type=script&lang=js"
import style0 from "./StarDivider.vue?vue&type=style&index=0&id=6ebfbf18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports